import React from "react";
import "./LibraryStyles.css";
import { Link } from "react-router-dom";
const EJournals = () => {
  return (
    <div className="library-page">
      <h1 className="library-title">E-Journals</h1>
      <p className="library-description">
        Explore our curated collection of peer-reviewed and scholarly e-journals to deepen your knowledge and stay informed.
      </p>

      <div className="library-grid">
        {/* Replace with dynamic content or database fetch */}
        <div className="library-item">
          <h3>Journal of Conscious Studies</h3>
          <p>Insights into human awareness and spiritual growth.</p>
          <Link to="#" className="library-link">Read Now</Link>
        </div>

        <div className="library-item">
          <h3>Mind & Thought Quarterly</h3>
          <p>Deep dives into psychology, mindfulness, and Indian philosophy.</p>
          <Link to="#" className="library-link">Read Now</Link>
        </div>
      </div>
    </div>
  );
};

export default EJournals;
